export default __webpack_public_path__ + "a65656bc2cd3be29305c6a76dc7343e9.webp";